import React from 'react';

import styles from './awardsStyles';

import Table from 'buyside/components/presentation/Table/table';
import Badges from 'buyside/components/presentation/Badges/badges';
import UserRankingLineChart from 'buyside/components/presentation/Charts/UserRankingLineChart/userRankingLineChart';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

const Awards = ({ userProfile }) => {
  const { historicalPublicRankings, userBadges } = userProfile.user;
  return (
    <div>
      <div className={styles.awardsSection}>
        <h4>Badges</h4>
        <div className={styles.badges}>
          <Badges
            userBadges={userBadges.edges}
            inline
            badgeClass={styles.largeBadge}
            showExtendedInfo
          />
        </div>
      </div>
      {!!historicalPublicRankings.length && (
        <div className={styles.awardsSection}>
          <h4>Rankings</h4>
          <div className={styles.rankingsTable}>
            <Table
              headings={['Category', 'Times Awarded', 'Best Rank', 'Current Rank']}
              items={historicalPublicRankings.map(ranking => JSON.parse(ranking))}
              getItemAttrs={ranking => [
                ranking.category,
                ranking.times_awarded,
                ranking.best_value,
                ranking.current_value
              ]}
              rowClassName={styles.rankingsTableRow}
            />
          </div>
        </div>
      )}
      <div className={styles.awardsSection}>
        <ErrorBoundary pageName="rankings graph">
          <UserRankingLineChart profileId={userProfile.id} />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Awards;
